<template>
  <div class="higgs">
    <!--    第一板块    -->
    <div class="higgs_module_1">
      <div class="higgs_module_1_div">
        <!--    左边文字    -->
        <div class="higgs_module_1_left">
          <div class="higgs_module_1_left_text1">
            <div>{{ $t('WELCOME') }}<br />{{ $t('HIGGS TECHNOLOG') }}</div>
          </div>

          <div
            class="higgs_module_1_left_business"
            @click="contactsDialogVisible = true"
          >
            <img
              src="@/assets/image/business.png"
              class="higgs_module_1_left_business__img"
              alt
            />
            Business Contacts
          </div>

          <div class="higgs_module_1_left_text2">
            <span
              >———&nbsp;&nbsp;&nbsp;&nbsp;{{
                $t('We make Web3.0 accessible！')
              }}&nbsp;&nbsp;&nbsp;&nbsp;———</span
            >
          </div>

          <div class="higgs_module_1_left_text3">
            <div @click="upload()" class="higgs_module_1_upload">
              <img
                class="higgs_module_1_img3"
                referrerpolicy="no-referrer"
                src="@/assets/image/higgs_module_1_img3.png"
              />
              <img
                class="higgs_module_1_img_upload"
                referrerpolicy="no-referrer"
                src="@/assets/image/higgs_module_1_img4.png"
              />
            </div>

            <div @click="goToIntroduce()" class="higgs_module_1_img2">
              {{ $t('PRODUCT') }}
            </div>
          </div>
        </div>

        <!--    右边GIF图    -->
        <div class="higgs_module_1_right">
          <div class="higgs_module_1_right_img">
            <img
              class="higgs_module_1_img1"
              referrerpolicy="no-referrer"
              src="@/assets/image/higgs_module_1_img1.gif"
            />
          </div>
        </div>
      </div>

      <!--    底部长GIF图    -->
      <div>
        <img
          class="higgs_module_1_img4"
          referrerpolicy="no-referrer"
          src="@/assets/image/higgs_module_1_img4.gif"
        />
      </div>
    </div>

    <!--    Mobile    -->
    <div class="higgs_module_2_mobile">
      <div class="higgs_module_mobile">
        <div class="mobile_label"></div>
        <div class="mobile_label_text">{{ $t('ABOUT HIGGS') }}</div>
        <div class="mobile_content1">
          {{
            $t(
              'The Higgs takes its name from the Higgs boson, also known as the God particle, which is the first elementary scalar particle to be discovered in nature.'
            )
          }}
          <br />
          {{
            $t(
              'As a technology-driven company, Higgs Technology is dedicated to providing secure, reliable, efficient, and sustainable solutions that create greater value for its customers and partners. '
            )
          }}
        </div>
        <div class="mobile_content2">
          {{
            $t(
              'Higgs Technology specializes in blockchain infrastructure, Web3 DApp development, smart contract programming, NFTs, and more, actively promoting the deep integration of blockchain technology with the real economy. '
            )
          }}
        </div>
        <div class="mobile_content2_image">
          <img
            src="@/assets/image/higgs_module_3_img2.png"
            class="mobile_content2_img"
            alt
          />
        </div>
        <div class="mobile_content3">
          <div class="mobile_content3_image1">
            <img
              src="@/assets/image/higgs_module_content2_1_left2.png"
              class="mobile_content3_img"
              alt
            />
          </div>
          <div class="mobile_content3_text1">
            {{
              $t('Huniu OS基于原生系统构建，融合区块链基础设施与沙盒隔离技术')
            }}
          </div>
          <div class="mobile_content3_text2">
            {{ $t('Huniu OS 为Web3 DApps提供了：') }}
          </div>
          <div class="mobile_content3_advantage">
            <div
              v-for="(item, index) in advantageList2"
              :key="index"
              class="mobile_content3_adv"
            >
              <div class="mobile_content3_adv_image">
                <img :src="item.img" class="mobile_content3_adv_img" alt />
              </div>
              <div class="mobile_content3_adv_name">{{ item.name }}</div>
            </div>
          </div>
          <div class="mobile_content3_image2">
            <img
              src="@/assets/image/higgs_module_content2_3_right2.png"
              class="mobile_content3_img"
              alt
            />
          </div>
          <div class="mobile_content3_text3">
            {{ $t('YLEM — High Security and Scalability') }}
          </div>
          <div class="mobile_content3_text4">
            {{
              $t(
                'Ylem is a Layer-1 public blockchain with high reliability, strong compatibility and low gas fee. It is the basic component of the entire HUNIU OS.'
              )
            }}
          </div>
        </div>
        <div class="mobile_label"></div>
        <div class="mobile_label_text">{{ $t('Hardware Tech') }}</div>
        <div class="mobile_content4">
          <div class="mobile_content4_title">
            {{ $t('Higgs Particle SoC Hardware Tech') }}
          </div>
          <div class="mobile_content4_text">
            {{
              $t(
                'Higgs’s original micro-kernel integrated SoC technology, whose main function is to carry on the public blockchain nodes, allows developers to easily build various DAPP, expand the Ylem ecology, and let the blockchain technology serve the entity.'
              )
            }}
          </div>

          <div
            v-for="(item, index) in hardwareList2"
            :key="index"
            class="mobile_content4_hardware"
          >
            <img :src="item.img" class="higgs_module_image" alt />
            <div class="higgs_module_text">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="mobile_content5">
        <div class="higgs_module_bg">
          <div class="higgs_module_4_title">{{ $t('愿景和使命') }}</div>
          <div class="higgs_module_4_text1">
            {{
              $t(
                '我们坚持硬件生产与软件开发融合推进，不断构建和完善企业业务板块，努力提升企业核心竞争力。'
              )
            }}
          </div>
          <div class="higgs_module_4_text2">
            {{ $t('构建一个完善的Web3生态') }}<br />{{ $t('让每个人畅游元宇宙')
            }}<br />{{ $t('通过DAO共享加密经济') }}<br />{{
              $t('每个人都可以通过HIGGS Web3.0计算机和HUNIU OS进入Web3.0世界。')
            }}
          </div>
        </div>
      </div>
    </div>

    <!--    第二板块    -->
    <div class="higgs_module_2">
      <div class="higgs_module_label"></div>
      <div class="higgs_module_label_text">{{ $t('ABOUT HIGGS') }}</div>

      <div class="higgs_module_content1">
        <div class="higgs_module_2_left">
          <div>
            {{
              $t(
                'The Higgs takes its name from the Higgs boson, also known as the God particle, which is the first elementary scalar particle to be discovered in nature.'
              )
            }}
          </div>
          <br />
          <div>
            {{
              $t(
                'As a technology-driven company, Higgs Technology is dedicated to providing secure, reliable, efficient, and sustainable solutions that create greater value for its customers and partners. '
              )
            }}
          </div>
        </div>

        <div class="higgs_module_2_right">
          {{
            $t(
              'Higgs Technology specializes in blockchain infrastructure, Web3 DApp development, smart contract programming, NFTs, and more, actively promoting the deep integration of blockchain technology with the real economy. '
            )
          }}
          <div class="higgs_module_2_right_img">
            <img
              src="@/assets/image/higgs_module_3_img2.png"
              class="higgs_module_3_img2"
              alt
            />
          </div>
        </div>
      </div>

      <div class="higgs_module_content2">
        <div class="higgs_module_content2_1">
          <div class="higgs_module_content2_1_left">
            <img
              src="@/assets/image/higgs_module_content2_1_left.png"
              class="higgs_module_content2_1_left_img"
              alt
            />
          </div>
          <div class="higgs_module_content2_1_right">
            {{
              $t('Huniu OS基于原生系统构建，融合区块链基础设施与沙盒隔离技术')
            }}
          </div>
        </div>

        <div class="higgs_module_content2_2">
          <div class="higgs_module_content2_2_left">
            {{ $t('Huniu OS 为Web3 DApps提供了：') }}
          </div>
          <div class="higgs_module_content2_2_right">
            <div
              class="advantage_div"
              v-for="(item, index) in advantageList"
              :key="index"
            >
              <img class="advantage_div_img" :src="item.img" alt />
              <div class="advantage_div_name">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="higgs_module_content2_3">
          <div class="higgs_module_content2_3_left">
            <div class="higgs_module_content2_3_left_text1">
              {{ $t('YLEM — High Security and Scalability') }}
            </div>
            <div class="higgs_module_content2_3_left_text2">
              {{
                $t(
                  'Ylem is a Layer-1 public blockchain with high reliability, strong compatibility and low gas fee. It is the basic component of the entire HUNIU OS.'
                )
              }}
            </div>
          </div>
          <div class="higgs_module_content2_3_right">
            <img
              src="@/assets/image/higgs_module_content2_3_right.png"
              class="higgs_module_content2_3_right_img"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!--    第三板块    -->
    <div class="higgs_module_3">
      <div class="higgs_module_label"></div>
      <div class="higgs_module_label_text">{{ $t('Hardware Tech') }}</div>

      <div class="higgs_module_body">
        <div class="higgs_module_title">
          {{ $t('Higgs Particle SoC Hardware Tech') }}
        </div>
        <div class="higgs_module_content">
          {{
            $t(
              'Higgs’s original micro-kernel integrated SoC technology, whose main function is to carry on the public blockchain nodes, allows developers to easily build various DAPP, expand the Ylem ecology, and let the blockchain technology serve the entity.'
            )
          }}
        </div>
      </div>

      <div class="higgs_module_hardware">
        <div
          v-for="(item, index) in hardwareList"
          :key="index"
          class="higgs_module_img"
        >
          <img :src="item.img" class="higgs_module_image" alt />
          <div class="higgs_module_text">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!--    第四板块    -->
    <div class="higgs_module_4">
      <div class="higgs_module_bg">
        <div class="higgs_module_4_title">{{ $t('愿景和使命') }}</div>
        <div class="higgs_module_4_text1">
          {{
            $t(
              '我们坚持硬件生产与软件开发融合推进，不断构建和完善企业业务板块，努力提升企业核心竞争力。'
            )
          }}
        </div>
        <div class="higgs_module_4_text2">
          {{ $t('构建一个完善的Web3生态') }}<br />{{ $t('让每个人畅游元宇宙')
          }}<br />{{ $t('通过DAO共享加密经济') }}<br />{{
            $t('每个人都可以通过HIGGS Web3.0计算机和HUNIU OS进入Web3.0世界。')
          }}
        </div>
      </div>
    </div>

    <!--    留言    -->
    <div class="higgs_module_7">
      <img
        class="leave_a_email"
        referrerpolicy="no-referrer"
        src="@/assets/image/leave_a_email.png"
        @click="leaveAEmail()"
      />
      <img
        class="leave_a_twitter"
        referrerpolicy="no-referrer"
        src="@/assets/image/leave_a_twitter.png"
        @click="leaveATwitter()"
      />
      <img
        class="leave_a_message"
        referrerpolicy="no-referrer"
        src="@/assets/image/leave_a_message.png"
        @click="leaveAMessage()"
      />

      <img
        class="back_to_top"
        referrerpolicy="no-referrer"
        src="@/assets/image/back_to_top.png"
        @click="backToTop()"
      />
    </div>

    <!--    留言弹框    -->
    <el-dialog
      :title="$t('问题反馈（留言）')"
      :visible.sync="leaveAMessageVisible"
      :modal="false"
      :close-on-click-modal="false"
      @close="leaveAMessageDialogClosed"
      :append-to-body="true"
      class="leaveAMessageClass"
    >
      <el-form
        :model="leaveAMessageForm"
        :rules="leaveAMessageRules"
        ref="leaveAMessageForm"
        label-width=""
        class="leaveAMessageForm"
      >
        <el-form-item label="" prop="desc">
          <el-input
            type="textarea"
            v-model="leaveAMessageForm.desc"
            :placeholder="$t('编辑文字...')"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item>
          <div class="leaveAMessageForm_text">
            {{ $t('注：问题反馈回复为一个工作日之内') }}<br /><br />
            {{ $t('周一至周五9:00~18:00') }}
          </div>
          <el-button
            @click="submitLeaveAMessage(leaveAMessageForm)"
            class="leaveAMessageForm_button"
            >{{ $t('反馈') }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--    联系人  -->
    <el-dialog
      :visible.sync="contactsDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      class="higgs_module_contacts"
    >
      <img
        class="higgs_module_contacts_img"
        referrerpolicy="no-referrer"
        src="@/assets/image/higgs_module_contacts.png"
      />
    </el-dialog>
  </div>
</template>

<script>
import store from './store'
export default {
  data() {
    return {
      // 留言对话框（true，打开，false，关闭）
      leaveAMessageVisible: false,
      // 留言表单
      leaveAMessageForm: {
        // 文本
        desc: '',
      },
      // 留言表单验证
      leaveAMessageRules: {
        // 文本
        desc: [
          {
            required: true,
            message: '请输入您的问题反馈（留言）！',
            trigger: 'blur',
          },
        ],
      },
      // 语言
      languageValue: 3,
      // token
      token: 0,
      // 用户编码
      userCode: '',
      // 联系人弹框
      contactsDialogVisible: false,
      // 优势
      advantageList: [
        {
          name: this.$t('安全'),
          img: require('@/assets/image/advantage_1.png'),
        },
        {
          name: this.$t('易用'),
          img: require('@/assets/image/advantage_2.png'),
        },
        {
          name: this.$t('可扩展'),
          img: require('@/assets/image/advantage_3.png'),
        },
        {
          name: this.$t('经济高效'),
          img: require('@/assets/image/advantage_4.png'),
        },
        {
          name: this.$t('对开发者友好的运行环境'),
          img: require('@/assets/image/advantage_5.png'),
        },
      ],
      advantageList2: [
        {
          name: this.$t('安全'),
          img: require('@/assets/image/advantage_1_1.png'),
        },
        {
          name: this.$t('易用'),
          img: require('@/assets/image/advantage_2_1.png'),
        },
        {
          name: this.$t('可扩展'),
          img: require('@/assets/image/advantage_3_1.png'),
        },
        {
          name: this.$t('经济高效'),
          img: require('@/assets/image/advantage_4_1.png'),
        },
        {
          name: this.$t('对开发者友好的运行环境'),
          img: require('@/assets/image/advantage_5_1.png'),
        },
      ],
      // 硬件
      hardwareList: [
        {
          name: this.$t('轻松构建属于自己的DAPP'),
          img: require('@/assets/image/higgs_module_3_img_1.png'),
        },
        {
          name: this.$t('拥有较为完善的生态体系—YLEM'),
          img: require('@/assets/image/higgs_module_3_img_2.png'),
        },
        {
          name: this.$t('区块链技术兼顾实体发展'),
          img: require('@/assets/image/higgs_module_3_img_3.png'),
        },
      ],
      hardwareList2: [
        {
          name: this.$t('轻松构建属于自己的DAPP'),
          img: require('@/assets/image/higgs_module_3_img_1_1.png'),
        },
        {
          name: this.$t('拥有较为完善的生态体系—YLEM'),
          img: require('@/assets/image/higgs_module_3_img_2_2.png'),
        },
        {
          name: this.$t('区块链技术兼顾实体发展'),
          img: require('@/assets/image/higgs_module_3_img_3_3.png'),
        },
      ],
    }
  },
  methods: {
    upload() {
      window.location.href =
        'https://huniuos.oss-cn-shanghai.aliyuncs.com/exe/Huniu_Web3_OS.exe'
    },
    // 返回直顶部
    backToTop() {
      this.$scrollTo()
    },
    // 清除留言反馈数据
    leaveAMessageDialogClosed() {
      this.$refs.leaveAMessageForm.resetFields()
    },
    // 提交留言
    submitLeaveAMessage() {
      var that = this

      // 语言选择
      const language = store.state.language ? store.state.language : '1'
      that.languageValue = language
      // 登录状态
      const token = store.state.token
        ? store.state.token
        : window.sessionStorage.getItem('token')
      const userCode = store.state.token
        ? store.state.token
        : window.sessionStorage.getItem('userCode')
      if (token == 1) {
        that.token = 1
      } else if (token == 0) {
        that.token = 0
      }

      that.userCode = userCode

      that.$refs.leaveAMessageForm.validate((valid) => {
        if (valid) {
          // 添加留言信息接口
          that
            .$http({
              url: '/Message/addMessage/' + that.languageValue,
              method: 'POST',
              data: {
                content: that.leaveAMessageForm.desc,
              },
              withCredentials: true,
              crossDomain: true,
              //解决跨域问题，不加无法跨域
              emulateJSON: true,
            })
            .then((response) => {
              console.log(response)

              if (response.data.state === 1) {
                // 关闭留言弹框
                that.leaveAMessageVisible = false

                that.$message({
                  message: $t('提交问题反馈（留言）成功！'),
                  type: 'success',
                  duration: 3000,
                })
              } else {
                that.$message({
                  message: response.data.msg,
                  type: 'error',
                  duration: 3000,
                })
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 电脑介绍页
    goToIntroduce() {
      this.$router.push('./HiggsIntroduce')

      // 使用方法
      this.$scrollTo()
    },
    // 打开留言
    leaveAMessage() {
      var that = this
      const token = store.state.token
        ? store.state.token
        : window.sessionStorage.getItem('token')
      if (token == 1) {
        that.token = 1
        that.leaveAMessageVisible = true
      } else if (token == 0 || token == null) {
        that.token = 0
        that.$message({
          message: that.$t('Please log in to your account first!'),
          type: 'warning',
          duration: 3000,
        })
      }
    },
    // 邮箱
    leaveAEmail() {
      window.open('mailto:higgsweb3@gmail.com', '_blank')
    },
    // Twitter
    leaveATwitter() {
      window.open('https://twitter.com/HiggsWeb3', '_blank')
    },
  },
  created() {
    var that = this
    // 语言选择
    const language = store.state.language ? store.state.language : '1'
    that.languageValue = language
    // 登录状态
    const token = store.state.token
      ? store.state.token
      : window.sessionStorage.getItem('token')
    if (token == 1) {
      that.token = 1
    } else if (token == 0) {
      that.token = 0
    }
  },
}
</script>

<style lang="scss" scope>
.higgs {
  z-index: 1;
  width: 100%;
  height: 100%;
  background: #edf4ff;

  .higgs_module_1 {
    padding: 64px 0 0 0;
    background: linear-gradient(to bottom, #86afe9 0%, #edf4ff 30%);

    .higgs_module_1_div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .higgs_module_1_left {
        width: 100%;
        height: auto;
        margin: 0 0 0 8.3%;

        .higgs_module_1_left_text1 {
          width: 100%;
          height: auto;
          font-weight: bold;
          font-size: 64px;
          color: #000000;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 0 0 0 0;
        }

        .higgs_module_1_left_business {
          width: fit-content;
          height: auto;

          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          border-radius: 40px 40px 40px 40px;
          border: 2px solid #000000;
          padding: 6px 21px 6px 21px;
          margin: 42px 0 0 0;

          font-weight: normal;
          font-size: 20px;
          color: #000000;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          &__img {
            width: 24px;
            height: 21px;
            object-fit: contain;
            margin: 0 12px 0 0;
          }
        }

        .higgs_module_1_left_text2 {
          width: auto;
          height: 28px;
          font-weight: normal;
          font-size: 20px;
          color: #2064ff;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 53px 0 0 0;
        }

        .higgs_module_1_left_text3 {
          display: flex;
          justify-content: start;
          align-items: center;
          margin: 41px 0 0 0;

          .higgs_module_1_img2 {
            width: auto;
            height: 40px;
            background: linear-gradient(267deg, #5d8eff 0%, #003ecd 100%);
            border-radius: 40px 40px 40px 40px;

            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            font-weight: normal;
            font-size: 20px;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            padding: 0 10% 0 10%;
          }

          .higgs_module_1_upload {
            width: auto;
            height: 40px;
            background: #010722;
            border-radius: 40px 40px 40px 40px;
            padding: 0 30px 0 30px;
            margin: 0 10% 0 0;

            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            .higgs_module_1_img3 {
              width: 130px;
              height: 23px;
              object-fit: contain;
            }

            .higgs_module_1_img_upload {
              width: 21px;
              height: 21px;
              object-fit: contain;
              margin: 0 0 0 24px;
            }
          }
        }
      }

      .higgs_module_1_right {
        width: 100%;
        height: auto;

        .higgs_module_1_right_img {
          width: 100%;
          height: auto;

          .higgs_module_1_img1 {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .higgs_module_1_img4 {
      width: 100%;
      height: auto;

      margin: -5% 0 0 0;
    }
  }

  .higgs_module_2 {
    display: block;
    padding: 7% 13.5% 0 13.5%;
    background: linear-gradient(180deg, #fdfeff 0%, #edf4ff 100%);

    .higgs_module_label {
      position: relative;
      width: 100%;
      height: 71px;

      background-image: url('~@/assets/image/higgs_module_label_bg.png');
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .higgs_module_label_text {
      position: absolute;
      width: auto;
      height: 71px;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      line-height: 71px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin: -71px 0 0 7%;
    }

    .higgs_module_content1 {
      width: 100%;
      height: auto;
      min-height: 535px;
      display: flex;
      justify-content: center;
      // align-items: center;

      margin: 7% 0 0 0;
      background-image: url('~@/assets/image/higgs_module_content1_bg.png');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 40px 40px 40px 40px;

      .higgs_module_2_left {
        width: 53%;
        height: auto;

        font-weight: bold;
        font-size: 30px;
        color: #446189;
        line-height: 1.5em;
        text-align: left;
        font-style: normal;
        text-transform: none;

        padding: 4% 4% 4% 4%;
      }

      .higgs_module_2_right {
        width: 47%;
        height: auto;

        font-weight: normal;
        font-size: 24px;
        color: #446189;
        line-height: 1.5em;
        text-align: left;
        font-style: normal;
        text-transform: none;

        padding: 4% 4% 4% 4%;

        .higgs_module_2_right_img {
          width: 100%;
          height: auto;
          display: contents;
          .higgs_module_3_img2 {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .higgs_module_content2 {
      margin: 7% 0 0 0;
      width: calc(100% - 7.5%);
      height: auto;
      background: linear-gradient(
        to bottom,
        #1d4c8e 0%,
        #081528 29%,
        #000000 100%
      );
      border-radius: 40px 40px 40px 40px;
      padding: 6.5% 7.5% 8% 0;

      .higgs_module_content2_1 {
        display: flex;
        height: 431px;

        .higgs_module_content2_1_left {
          width: 432px;
          height: 431px;
          .higgs_module_content2_1_left_img {
            width: 432px;
            height: 431px;
            object-fit: contain;
          }
        }

        .higgs_module_content2_1_right {
          width: calc(89.5% - 200px);
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          font-size: 54px;
          color: #ffffff;
          line-height: 63px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .higgs_module_content2_2 {
        display: flex;
        align-items: center;
        margin: 2.5% 0 0 0;
        padding: 0 0 0 7.5%;
        width: calc(100% - 7.5%);
        height: auto;

        .higgs_module_content2_2_left {
          width: 330px;
          height: 100%;
          font-weight: bold;
          font-size: 48px;
          color: #719bff;
          line-height: 56px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 0 0 0 0;
        }

        .higgs_module_content2_2_right {
          width: calc(100% - 330px);
          height: auto;
          display: flex;
          justify-content: start;
          align-items: center;
          flex-wrap: wrap;

          .advantage_div {
            position: relative;
            width: 141px;
            height: 192px;

            display: flex;
            justify-content: center;
            align-items: flex-start;

            padding: 0 0 0 0;
            margin: 0 12px 12px 12px;

            .advantage_div_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .advantage_div_name {
              width: calc(141px - 10%);
              height: 3em;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              line-height: 1.5em;
              text-align: center;
              font-style: normal;
              text-transform: none;

              position: absolute;
              bottom: 0;
              margin: 0 0 8px 0;
            }
          }
        }
      }

      .higgs_module_content2_3 {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin: 7.5% 0 0 0;
        padding: 0 0 0 7.5%;
        width: calc(100% - 7.5%);
        height: auto;

        .higgs_module_content2_3_left {
          width: calc(100% - 431px);
          height: auto;

          .higgs_module_content2_3_left_text1 {
            font-weight: bold;
            font-size: 54px;
            color: #ffffff;
            line-height: 63px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .higgs_module_content2_3_left_text2 {
            font-weight: bold;
            font-size: 40px;
            color: #719bff;
            line-height: 47px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin: 11% 0 0 0;
          }
        }

        .higgs_module_content2_3_right {
          width: 431px;
          height: 431px;
          .higgs_module_content2_3_right_img {
            width: 431px;
            height: 431px;
            object-fit: contain;
          }
        }
      }
    }
  }

  .higgs_module_2_mobile {
    display: none;
  }

  .higgs_module_3 {
    padding: 7% 13.5% 0 13.5%;

    .higgs_module_label {
      position: relative;
      width: 100%;
      height: 71px;

      background-image: url('~@/assets/image/higgs_module_label_bg.png');
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .higgs_module_label_text {
      position: absolute;
      width: auto;
      height: 71px;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      line-height: 71px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin: -71px 0 0 7%;
    }

    .higgs_module_body {
      margin: 7% 0 0 0;
      padding: 0 7.1% 0 7.1%;

      .higgs_module_title {
        font-weight: bold;
        font-size: 40px;
        color: #446189;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .higgs_module_content {
        font-weight: normal;
        font-size: 24px;
        color: #446189;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 4.65% 0 0 0;
      }
    }

    .higgs_module_hardware {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 7% 0 0 0;

      .higgs_module_img {
        width: calc(100% / 3 - 20px);
        height: auto;
        margin: 0 20px;
        position: relative;

        .higgs_module_image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .higgs_module_text {
          position: absolute;
          bottom: 0;
          width: calc(100% - 48px);
          height: calc(100% - 5%);
          font-weight: bold;
          font-size: 36px;
          color: #ffffff;
          line-height: 1.3em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 0 24px 5% 24px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }
      }
    }
  }

  .higgs_module_4 {
    width: 100%;
    height: 1600px;
    margin: 7% 0 0 0;
    background-image: url('~@/assets/image/higgs_module_4_bg.png');
    background-position: center center;
    background-size: cover;
    display: flex;
    justify-content: center;

    .higgs_module_bg {
      width: 1600px;
      height: 1600px;
      background-image: url('~@/assets/image/higgs_module_4_bg2.png');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;

      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;

      margin: -7.8% 0 0 0;

      .higgs_module_4_title {
        font-weight: bold;
        font-size: 60px;
        color: #2064ff;
        line-height: 70px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .higgs_module_4_text1 {
        font-weight: bold;
        font-size: 40px;
        color: #446189;
        line-height: 1.75em;
        text-align: left;
        font-style: normal;
        text-transform: none;

        padding: 0 22%;
        margin: 4.75% 0 0 0;
      }

      .higgs_module_4_text2 {
        font-weight: bold;
        font-size: 40px;
        color: #446189;
        line-height: 1.75em;
        text-align: left;
        font-style: normal;
        text-transform: none;

        padding: 0 22%;
        margin: 4.75% 0 0 0;
      }
    }
  }
}

.higgs_module_7 {
  z-index: 2;
  bottom: 10%;
  right: 4.65%;
  position: fixed;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: column;

  padding: 13px 0 24px 0;

  width: 60px;
  height: auto;
  background: #2064ff;
  border-radius: 50px;

  .leave_a_email {
    width: 41px;
    height: 41px;
    object-fit: contain;
    cursor: pointer;
    margin: 0 0 19px 0;
  }

  .leave_a_twitter {
    width: 41px;
    height: 41px;
    object-fit: contain;
    cursor: pointer;
    margin: 0 0 19px 0;
  }
  .leave_a_message {
    width: 41px;
    height: 41px;
    object-fit: contain;
    cursor: pointer;
    margin: 0 0 34px 0;
  }

  .back_to_top {
    width: 25px;
    height: 28px;
    object-fit: contain;
    cursor: pointer;
  }
}

.leaveAMessageClass {
  .el-dialog {
    width: 800px;
    box-shadow: 8px 6px 27px 2px rgba(25, 28, 114, 0.5);
    .el-dialog__header {
      height: 50px;
      background: #2064ff;

      .el-dialog__title {
        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 25px;
      }
    }

    .el-dialog__body {
      padding: 15px 20px 10px 20px;
      .el-form {
        margin: 0 0 0 0;
        width: 760px;
      }
      .el-textarea__inner {
        width: 760px;
        height: 311px;
        border: 1px solid #b8b8b8;
        padding: 17px 19px 17px 19px;

        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #010722;
        line-height: 25px;
        opacity: 0.5;
      }
      .el-textarea__inner::placeholder {
        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #010722;
        line-height: 25px;
        opacity: 0.5;
      }

      .el-textarea {
        width: 760px;
      }
      .el-form-item__content {
        font-size: 17px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #b7b7b7;
        line-height: 17px;
      }
      .leaveAMessageForm_text {
        font-size: 17px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #b7b7b7;
        line-height: 25px;
        width: 300px !important;
      }
      .leaveAMessageForm_button {
        width: 150px;
        height: 60px;
        background: #2064ff;
        border-radius: 29px;

        font-size: 25px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 25px;

        margin: 0 0 0 306px;
      }
    }
  }
}
.el-form-item__error {
  width: 600px;
}

.higgs_module_contacts {
  .el-dialog {
    .el-dialog__body {
      text-align: center;

      .higgs_module_contacts_img {
        width: 400px;
        height: 400px;
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .higgs {
    z-index: 1;
    width: 100%;
    height: 100%;
    background: #edf4ff;

    .higgs_module_1 {
      padding: 44px 0 0 0;
      background: linear-gradient(to bottom, #86afe9 0%, #edf4ff 30%);

      .higgs_module_1_div {
        width: calc(100% - 8.3%);
        display: flex;
        flex-direction: column;
        padding: 0 4.15% 0 4.15%;

        .higgs_module_1_left {
          width: 100%;
          height: auto;
          margin: 0 0 0 0;

          .higgs_module_1_left_text1 {
            width: 100%;
            height: auto;
            font-weight: bold;
            font-size: 56px;
            color: #3a599b;
            line-height: 1.5em;
            text-align: center;
            font-style: normal;
            text-transform: none;

            margin: 0 0 0 0;
          }

          .higgs_module_1_left_business {
            width: fit-content;
            height: auto;

            display: flex;
            justify-content: center;
            align-items: center;

            display: none;
            cursor: pointer;

            border-radius: 40px 40px 40px 40px;
            border: 2px solid #000000;
            padding: 6px 21px 6px 21px;
            margin: 42px 0 0 0;

            font-weight: normal;
            font-size: 20px;
            color: #000000;
            line-height: 23px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            &__img {
              width: 24px;
              height: 21px;
              object-fit: contain;
              margin: 0 12px 0 0;
            }
          }

          .higgs_module_1_left_text2 {
            display: none;
            width: auto;
            height: 28px;
            font-weight: normal;
            font-size: 20px;
            color: #2064ff;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 53px 0 0 0;
          }

          .higgs_module_1_left_text3 {
            position: absolute;
            display: flex;
            justify-content: start;
            align-items: center;
            flex-direction: column;
            flex-flow: wrap-reverse;
            margin: 70% 0 0 0;

            padding: 0 20% 0 20%;

            .higgs_module_1_img2 {
              width: 100%;
              height: 40px;
              background: linear-gradient(267deg, #5d8eff 0%, #003ecd 100%);
              border-radius: 40px 40px 40px 40px;

              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              font-weight: normal;
              font-size: 20px;
              color: #ffffff;
              line-height: 40px;
              text-align: center;
              font-style: normal;
              text-transform: none;

              padding: 0 0 0 0;
              margin: 0 0 40px 0;
            }

            .higgs_module_1_upload {
              width: calc(100% - 30px);
              height: 40px;
              background: #010722;
              border-radius: 40px 40px 40px 40px;
              padding: 0 15px 0 15px;
              margin: 0 0 0 0;

              display: flex;
              justify-content: space-between;
              align-items: center;
              cursor: pointer;

              .higgs_module_1_img3 {
                width: 130px;
                height: 23px;
                object-fit: contain;
              }

              .higgs_module_1_img_upload {
                width: 21px;
                height: 21px;
                object-fit: contain;
                margin: 0 0 0 24px;
              }
            }
          }
        }

        .higgs_module_1_right {
          margin: 0 0 0 0;
          width: 100%;
          height: auto;

          .higgs_module_1_right_img {
            width: 100%;
            height: auto;

            .higgs_module_1_img1 {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }

      .higgs_module_1_img4 {
        width: 100%;
        height: auto;

        margin: -5% 0 0 0;
      }
    }

    .higgs_module_2_mobile {
      display: block;
      width: 100%;
      height: auto;
      background: linear-gradient(180deg, #fdfeff 0%, #9bb9e3 100%);

      .higgs_module_mobile {
        display: block;
        width: calc(100% - 8.3%);
        height: auto;
        padding: 81px 4.15% 0 4.15%;

        .mobile_label {
          width: 100%;
          height: 38px;

          background-image: url('~@/assets/image/higgs_module_label_bg2.png');
          background-position: left center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        .mobile_label_text {
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          line-height: 38px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: -38px 0 0 0;
          padding: 0 0 0 15%;
        }
        .mobile_content1 {
          width: calc(100% - 40%);
          height: calc(332px - 22%);

          background-image: url('~@/assets/image/higgs_module_content1_bg2.png');
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;

          font-weight: bold;
          font-size: 16px;
          color: #446189;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 12% 20% 10% 20%;
          margin: 44px 0 0 0;
        }
        .mobile_content2 {
          width: calc(100% - 40%);
          height: calc(100% - 40%);
          background: linear-gradient(
            269deg,
            rgba(255, 255, 255, 0) 0%,
            #ffffff 100%
          );
          box-shadow: 0px 20px 50px 2px rgba(166, 187, 220, 0.3);
          border-radius: 0 0 30px 30px;

          font-weight: normal;
          font-size: 16px;
          color: #446189;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          padding: 20% 20% 20% 20%;
          margin: 0 0 0 0;
        }

        .mobile_content2_image {
          position: absolute;
          margin: -20% 0 0 0;
          width: calc(100% - 8.3%);
          height: 227px;
          text-align: center;
          .mobile_content2_img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .mobile_content3 {
          margin: 253px 0 122px 0;
          padding: 0 0 97px 0;

          width: 100%;
          height: auto;
          background: linear-gradient(180deg, #173c6f 0%, #010101 100%);
          border-radius: 30px 30px 30px 30px;

          .mobile_content3_image1 {
            width: 100%;
            height: 361px;
            text-align: center;
            .mobile_content3_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .mobile_content3_text1 {
            width: calc(100% - 46px);
            height: auto;

            font-weight: bold;
            font-size: 24px;
            color: #ffffff;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 23px 0 23px;
            margin: -56px 0 0 0;
          }

          .mobile_content3_text2 {
            width: calc(100% - 46px);
            height: auto;

            font-weight: bold;
            font-size: 16px;
            color: #719bff;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 23px 0 23px;
            margin: 46px 0 0 0;
          }

          .mobile_content3_advantage {
            width: calc(100% - 46px);
            height: auto;

            padding: 0 23px 0 23px;
            margin: 20px 0 0 0;

            .mobile_content3_adv {
              width: 100%;
              height: 88px;
              background: linear-gradient(
                180deg,
                rgba(29, 48, 76, 0) 0%,
                rgba(67, 113, 178, 0.5) 70%,
                rgba(112, 171, 255, 0.6) 100%
              );
              border-radius: 10px 10px 10px 10px;
              border: 1px solid #345076;
              margin: 0 0 16px 0;

              display: flex;
              align-items: center;

              .mobile_content3_adv_image {
                width: 80px;
                height: 80px;

                .mobile_content3_adv_img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }

              .mobile_content3_adv_name {
                width: calc(100% - 104px);
                height: 100%;

                display: flex;
                align-items: center;

                font-weight: bold;
                font-size: 21px;
                color: #ffffff;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                padding: 0 12px 0 12px;
              }
            }
          }

          .mobile_content3_image2 {
            width: 100%;
            height: 361px;
            text-align: center;
            .mobile_content3_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .mobile_content3_text3 {
            width: calc(100% - 46px);
            height: auto;

            font-weight: bold;
            font-size: 24px;
            color: #ffffff;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 23px 0 23px;
          }

          .mobile_content3_text4 {
            width: calc(100% - 46px);
            height: auto;
            font-weight: bold;
            font-size: 16px;
            color: #719bff;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 23px 0 23px;
            margin: 39px 0 0 0;
          }
        }

        .mobile_label {
          width: 100%;
          height: 38px;

          background-image: url('~@/assets/image/higgs_module_label_bg2.png');
          background-position: left center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        .mobile_label_text {
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          line-height: 38px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: -38px 0 0 0;
          padding: 0 0 0 15%;
        }

        .mobile_content4 {
          width: calc(100% - 8.5%);
          height: auto;
          padding: 34px 4.25% 0 4.25%;

          .mobile_content4_title {
            font-weight: bold;
            font-size: 24px;
            color: #446189;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 0 0 38px 0;
          }

          .mobile_content4_text {
            font-weight: normal;
            font-size: 16px;
            color: #446189;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 0 0 38px 0;
          }

          .mobile_content4_hardware {
            width: 100%;
            height: auto;
            position: relative;
            text-align: center;

            .higgs_module_image {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .higgs_module_text {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: calc(100% - 7%);

              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              line-height: 20px;
              text-align: center;
              font-style: normal;
              text-transform: none;

              padding: 0 0 7% 0;
              display: flex;
              justify-content: center;
              align-items: flex-end;
            }
          }
        }
      }
      .mobile_content5 {
        width: calc(100% - 8.3%);
        height: 1003px;
        margin: 0 0 0 0;
        background-image: url('~@/assets/image/higgs_module_4_bg_1.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        margin: -280px 0 0 0;
        padding: 0 4.15% 126px 4.15%;

        .higgs_module_bg {
          width: calc(100% - 24%);
          height: 612px;
          background-image: url('~@/assets/image/higgs_module_4_bg2_2.png');
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;

          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;

          margin: 0 0 0 0;
          padding: 0 12% 0 12%;

          .higgs_module_4_title {
            font-weight: bold;
            font-size: 30px;
            color: #2064ff;
            line-height: 70px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .higgs_module_4_text1 {
            font-weight: bold;
            font-size: 16px;
            color: #2f4768;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 0 0 0;
            margin: 40px 0 0 0;
          }

          .higgs_module_4_text2 {
            font-weight: bold;
            font-size: 16px;
            color: #2f4768;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 0 0 0;
            margin: 22px 0 0 0;
          }
        }
      }
    }

    .higgs_module_2 {
      display: none;
      padding: 7% 13.5% 0 13.5%;
      background: linear-gradient(180deg, #fdfeff 0%, #edf4ff 100%);

      .higgs_module_label {
        position: relative;
        width: 100%;
        height: 71px;

        background-image: url('~@/assets/image/higgs_module_label_bg.png');
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .higgs_module_label_text {
        position: absolute;
        width: auto;
        height: 71px;
        font-weight: bold;
        font-size: 30px;
        color: #ffffff;
        line-height: 71px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: -71px 0 0 7%;
      }

      .higgs_module_content1 {
        width: 100%;
        height: auto;
        min-height: 535px;
        display: flex;
        justify-content: center;
        // align-items: center;

        margin: 7% 0 0 0;
        background-image: url('~@/assets/image/higgs_module_content1_bg.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        border-radius: 40px 40px 40px 40px;

        .higgs_module_2_left {
          width: 53%;
          height: auto;

          font-weight: bold;
          font-size: 30px;
          color: #446189;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 4% 4% 4% 4%;
        }

        .higgs_module_2_right {
          width: 47%;
          height: auto;

          font-weight: normal;
          font-size: 24px;
          color: #446189;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 4% 4% 4% 4%;

          .higgs_module_2_right_img {
            width: 100%;
            height: auto;
            display: contents;
            .higgs_module_3_img2 {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }

      .higgs_module_content2 {
        margin: 7% 0 0 0;
        width: calc(100% - 7.5%);
        height: auto;
        background: linear-gradient(
          to bottom,
          #1d4c8e 0%,
          #081528 29%,
          #000000 100%
        );
        border-radius: 40px 40px 40px 40px;
        padding: 6.5% 7.5% 8% 0;

        .higgs_module_content2_1 {
          display: flex;
          height: 431px;

          .higgs_module_content2_1_left {
            width: 432px;
            height: 431px;
            .higgs_module_content2_1_left_img {
              width: 432px;
              height: 431px;
              object-fit: contain;
            }
          }

          .higgs_module_content2_1_right {
            width: calc(89.5% - 200px);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 54px;
            color: #ffffff;
            line-height: 63px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .higgs_module_content2_2 {
          display: flex;
          align-items: center;
          margin: 2.5% 0 0 0;
          padding: 0 0 0 7.5%;
          width: calc(100% - 7.5%);
          height: auto;

          .higgs_module_content2_2_left {
            width: 330px;
            height: 100%;
            font-weight: bold;
            font-size: 48px;
            color: #719bff;
            line-height: 56px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 0 0 0 0;
          }

          .higgs_module_content2_2_right {
            width: calc(100% - 330px);
            height: auto;
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: wrap;

            .advantage_div {
              position: relative;
              width: 141px;
              height: 192px;

              display: flex;
              justify-content: center;
              align-items: flex-start;

              padding: 0 0 0 0;
              margin: 0 12px 12px 12px;

              .advantage_div_img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }

              .advantage_div_name {
                width: calc(141px - 10%);
                height: 3em;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                line-height: 1.5em;
                text-align: center;
                font-style: normal;
                text-transform: none;

                position: absolute;
                bottom: 0;
                margin: 0 0 8px 0;
              }
            }
          }
        }

        .higgs_module_content2_3 {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin: 7.5% 0 0 0;
          padding: 0 0 0 7.5%;
          width: calc(100% - 7.5%);
          height: auto;

          .higgs_module_content2_3_left {
            width: calc(100% - 431px);
            height: auto;

            .higgs_module_content2_3_left_text1 {
              font-weight: bold;
              font-size: 54px;
              color: #ffffff;
              line-height: 63px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .higgs_module_content2_3_left_text2 {
              font-weight: bold;
              font-size: 40px;
              color: #719bff;
              line-height: 47px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin: 11% 0 0 0;
            }
          }

          .higgs_module_content2_3_right {
            width: 431px;
            height: 431px;
            .higgs_module_content2_3_right_img {
              width: 431px;
              height: 431px;
              object-fit: contain;
            }
          }
        }
      }
    }

    .higgs_module_3 {
      display: none;
      padding: 7% 13.5% 0 13.5%;

      .higgs_module_label {
        position: relative;
        width: 100%;
        height: 71px;

        background-image: url('~@/assets/image/higgs_module_label_bg.png');
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .higgs_module_label_text {
        position: absolute;
        width: auto;
        height: 71px;
        font-weight: bold;
        font-size: 30px;
        color: #ffffff;
        line-height: 71px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: -71px 0 0 7%;
      }

      .higgs_module_body {
        margin: 7% 0 0 0;
        padding: 0 7.1% 0 7.1%;

        .higgs_module_title {
          font-weight: bold;
          font-size: 40px;
          color: #446189;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .higgs_module_content {
          font-weight: normal;
          font-size: 24px;
          color: #446189;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 4.65% 0 0 0;
        }
      }

      .higgs_module_hardware {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 7% 0 0 0;

        .higgs_module_img {
          width: calc(100% / 3 - 20px);
          height: auto;
          margin: 0 20px;
          position: relative;

          .higgs_module_image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .higgs_module_text {
            position: absolute;
            bottom: 0;
            width: calc(100% - 24px);
            height: 30%;
            font-weight: bold;
            font-size: 36px;
            color: #ffffff;
            line-height: 1.3em;
            text-align: left;
            font-style: normal;
            text-transform: none;

            padding: 0 12px 0 12px;
            display: flex;
            align-items: center;
          }
        }
      }
    }

    .higgs_module_4 {
      width: 100%;
      height: 1600px;
      margin: 7% 0 0 0;
      background-image: url('~@/assets/image/higgs_module_4_bg.png');
      background-position: center end;
      background-size: cover;
      display: flex;
      justify-content: center;
      display: none;

      .higgs_module_bg {
        width: 1600px;
        height: 1600px;
        background-image: url('~@/assets/image/higgs_module_4_bg2.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;

        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;

        margin: -7.8% 0 0 0;

        .higgs_module_4_title {
          font-weight: bold;
          font-size: 60px;
          color: #2064ff;
          line-height: 70px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .higgs_module_4_text1 {
          font-weight: bold;
          font-size: 40px;
          color: #446189;
          line-height: 1.75em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 0 22%;
          margin: 4.75% 0 0 0;
        }

        .higgs_module_4_text2 {
          font-weight: bold;
          font-size: 40px;
          color: #446189;
          line-height: 1.75em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          padding: 0 22%;
          margin: 4.75% 0 0 0;
        }
      }
    }
  }

  .higgs_module_7 {
    z-index: 2;
    bottom: 10%;
    right: 4.65%;
    position: fixed;

    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: column;

    display: none;

    padding: 13px 0 24px 0;

    width: 60px;
    height: auto;
    background: #2064ff;
    border-radius: 50px;

    .leave_a_email {
      width: 41px;
      height: 41px;
      object-fit: contain;
      cursor: pointer;
      margin: 0 0 19px 0;
    }

    .leave_a_twitter {
      width: 41px;
      height: 41px;
      object-fit: contain;
      cursor: pointer;
      margin: 0 0 19px 0;
    }
    .leave_a_message {
      width: 41px;
      height: 41px;
      object-fit: contain;
      cursor: pointer;
      margin: 0 0 34px 0;
    }

    .back_to_top {
      width: 25px;
      height: 28px;
      object-fit: contain;
      cursor: pointer;
    }
  }
}
</style>